//Formule iz dela Thermodynamic parameters of the pool area
/************************/

const { sum } = require("d3");

//Aritmetic mean temperature
export function calculateAritmeticMeanTemperature(
  airTemperature,
  waterTemperature
) {
  return (+airTemperature + 273.15 + (+waterTemperature + 273.15)) / 2;
}
/************************/
//Formule iz dela Pressures
/************************/
//Partial water vapor saturation pressure at air temperature ϑw and for 100% relative humidity
export function calculatePartialWaterVaporSaturationPressure100(
  waterTemperature
) {
  return Math.exp(23.58 - 4044.2 / (235.6 + +waterTemperature));
}

//Partial saturation pressure of water vapor at air temperature ϑv and φv relative humidity
export function calculatePartialWaterVaporSaturationPressure(
  airTemperature,
  relativeHumidityPoolArea
) {
  return (
    (Math.exp(23.58 - 4044.2 / (235.6 + +airTemperature)) *
      +relativeHumidityPoolArea) /
    100
  );
}

/************************/
//Formule iz dela Absolute Humidity
/************************/
//Absolute humidity in the pool area
export function calculateAbsHumidityPoolArea(
  airTemperature,
  relativeHumidityPoolArea
) {
  return (
    (((0.622 * +relativeHumidityPoolArea) / 100) *
      ((Math.exp(23.58 - 4044.2 / (235.6 + +airTemperature)) * (100 / 100)) /
        100)) /
    (1000 -
      (+relativeHumidityPoolArea / 100) *
        ((Math.exp(23.58 - 4044.2 / (235.6 + +airTemperature)) * (100 / 100)) /
          100))
  );
}

/************************/
//Formule iz dela Attractions
/************************/

//Rel
export function calculateRelWildWater(numOfUnits) {
  return 30 * +numOfUnits;
}
export function calculateRelWaterMushrooms(numOfUnits, metersOfUnit) {
  return +numOfUnits * 5 * +metersOfUnit;
}
export function calculatRelNeckMassageShower(numOfUnits) {
  return 6 * +numOfUnits;
}
export function calculateRelUnderwaterJets(numOfUnits) {
  console.log(numOfUnits);
  return 4 * +numOfUnits;
}

export function calculateRelBubbleFontains(numOfUnits) {
  return 3 * +numOfUnits;
}

export function calculateRelChildrenSlides(numOfUnits) {
  return 3 * +numOfUnits;
}

export function calculateRelMassageAreas(numOfUnits) {
  return 4 * +numOfUnits;
}
export function calculateRelLoungersSeats(numOfUnits) {
  return 2 * +numOfUnits;
}

export function calculateAttractionsRel(name, numOfUnits) {
  switch (name) {
    case "wildWaterChannels":
      return 30 * numOfUnits;
    case "neckMassageShowers":
      return 6 * +numOfUnits;
    case "underwaterJets":
      return 4 * numOfUnits;
    case "bubbleFountains":
      return 3 * numOfUnits;
    case "childrenSlides":
      return 3 * numOfUnits;
    case "massageAreas":
      return 4 * numOfUnits;
    case "loungersSeats":
      return 2 * numOfUnits;
  }
}

//Sum
export function calculateAttractionsSUM(
  relBubbleFountains,
  relWildWater,
  relWaterMushrooms,
  relUnderwaterJets,
  relNeckMassageShower,
  relMassageAreas,
  relChildrenSlides,
  relLoungersSeats
) {
  console.log(
    relBubbleFountains,
    relWildWater,
    relWaterMushrooms, //un
    relUnderwaterJets,
    relNeckMassageShower,
    relMassageAreas,
    relChildrenSlides,
    relLoungersSeats
  );
  const sumOfRels =
    relWildWater +
    relWaterMushrooms +
    relNeckMassageShower +
    relUnderwaterJets +
    relBubbleFountains +
    relChildrenSlides +
    relMassageAreas +
    relLoungersSeats;
  console.log(sumOfRels);
  if (sumOfRels < 99) return sumOfRels;
  else return 99.99999;

  /* if (attractionsSum !== 0) {
    return forecast(attractionsSum, dataSum, dataDeltaB);
  } else return 0;*/
}

//BetaA
/*In summary, this Excel formula calculates a linear regression forecast for a given sum value using the data from the "baza" worksheet.
 It adjusts the range of Y and X values using the OFFSET function based on the position of sum value in the data, 
 and then it uses the FORECAST function to make the prediction.*/

export function forecast(attractionsSum, sumArray, deltaBetaA) {
  // Find the index of the closest date in the dateRange
  var indexSum = -1;

  //MATCH finds the largest value that is less than or equal to lookup_value
  for (var i = 0; i < sumArray.length; i++) {
    console.log(sumArray[i] + "je vece ili jednako" + attractionsSum);
    if (sumArray[i] >= attractionsSum) {
      console.log(sumArray[i] + "je vece ili jednako" + attractionsSum);
      console.log(
        "Index je:" +
          i +
          "vrednost je " +
          sumArray[i] +
          " a trazim za " +
          attractionsSum
      );
      indexSum = i;
      if (indexSum === 0) indexSum++;
      break;
    }
  }
  console.log(indexSum);
  // If the index is still -1, it means x43 is greater than all dates in the dateRange
  // In this case, you can handle it according to your requirements
  if (indexSum === -1) {
    // Handle the case where x43 is greater than all dates
    return null;
  }
  // sumArray[20];
  // Use the index to get the corresponding values from dataRange
  var x1 = sumArray[indexSum - 1];
  var x2 = sumArray[indexSum]; //+1
  var y1 = deltaBetaA[indexSum - 1];
  var y2 = deltaBetaA[indexSum]; //+1

  // Your known data
  const data = [
    [x1, y1],
    [x2, y2],
  ];
  console.log(data);

  // New X value you want to predict
  //const attractionsSum = 9;

  // Extract known x and y values
  const knownX = data.map((point) => point[0]);
  const knownY = data.map((point) => point[1]);

  // Calculate the slope (m) and y-intercept (b) of the linear regression line
  const sumX = knownX.reduce((acc, x) => acc + x, 0);
  const sumY = knownY.reduce((acc, y) => acc + y, 0);
  const sumXY = knownX.reduce((acc, x, i) => acc + x * knownY[i], 0);
  const sumX2 = knownX.reduce((acc, x) => acc + x * x, 0);

  const n = knownX.length;

  const slope = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX);
  const intercept = (sumY - slope * sumX) / n;

  // Predict the value for attractionsSum using the linear regression formula
  const predictedValue = slope * attractionsSum + intercept;

  console.log(`The forecasted value for x = 9 is: ${predictedValue}`);

  return predictedValue;
}

export function calculateAttractionsBetaA(attractionsSum, dataSum, dataDeltaB) {
  console.log("Suma je" + attractionsSum);
  console.log(forecast(attractionsSum, dataSum, dataDeltaB));
  if (attractionsSum !== 0) {
    return forecast(attractionsSum, dataSum, dataDeltaB);
  } else return 0;
}

/************************/
//Formule iz dela Maximum amount calculation of evaporated water
/************************/

//Moisture transfer coefficient(unused pool)
export function calculateMoistureTransferCoeffUnusedPool(typeOfPool) {
  switch (typeOfPool) {
    case "Covered pool (only the topping evaporates)":
      return 0.7;
    case "Private pool":
      return 7;
    case "Public pool depth < 1,35 m":
      return 7;
    case "Public pool depth > 1,35 m":
      return 7;
    case "Wave pool":
      return 7;
    case "Pool with water slide system":
      return 0;
    case "Water slide system for water collection":
      return 0;
  }
}
//Moisture transfer coefficient(used pool)
export function calculateMoistureTransferCoeffUsedPool(typeOfPool) {
  console.log(typeOfPool);
  switch (typeOfPool) {
    case "Covered pool (only the topping evaporates)":
      return 0;
    case "Private pool":
      return 21;
    case "Public pool depth < 1,35 m":
      return 40;
    case "Public pool depth > 1,35 m":
      return 28;
    case "Wave pool":
      return 50;
    case "Pool with water slide system":
      return 50;
    case "Water slide system for water collection":
      return 50;
  }
}

//Moisture transfer coefficient of attraction
//+BA iz attractionsa
export function calculateMoistureTransferCoeffAttractions(betaA) {
  return +betaA;
}

//The amount of moisture from visitors
export function calculateMoistureFromVisitors(numOfVisitors) {
  return 0.06 * +numOfVisitors;
}

//Mass flow of water (unused pool)
export function calculateMassFlowOfWaterUnusedPool(
  waterSurface,
  gasConst,
  typeOfPool,
  airTemperature,
  relativeHumidityPoolArea,
  waterTemperature
) {
  return (
    (calculateMoistureTransferCoeffUnusedPool(typeOfPool) /
      (gasConst *
        calculateAritmeticMeanTemperature(airTemperature, waterTemperature))) *
    (calculatePartialWaterVaporSaturationPressure100(waterTemperature) -
      calculatePartialWaterVaporSaturationPressure(
        airTemperature,
        relativeHumidityPoolArea
      )) *
    waterSurface
  );
}
//Mass flow of water (used pool)
export function calculateMassFlowOfWaterUsedPool(
  waterSurface,
  gasConst,
  typeOfPool,
  airTemperature,
  relativeHumidityPoolArea,
  waterTemperature
) {
  return (
    (calculateMoistureTransferCoeffUsedPool(typeOfPool) /
      (gasConst *
        calculateAritmeticMeanTemperature(airTemperature, waterTemperature))) *
    (calculatePartialWaterVaporSaturationPressure100(waterTemperature) -
      calculatePartialWaterVaporSaturationPressure(
        airTemperature,
        relativeHumidityPoolArea
      )) *
    waterSurface
  );
}

//Mass flow of water from the attraction
export function calculateMassFlowOfWaterAttraction(
  waterSurface,
  gasConst,
  typeOfPool,
  airTemperature,
  relativeHumidityPoolArea,
  waterTemperature,
  betaA
) {
  return (
    (calculateMoistureTransferCoeffAttractions(betaA) / //izmni nakon implementacije metode
      (gasConst *
        calculateAritmeticMeanTemperature(airTemperature, waterTemperature))) *
    (calculatePartialWaterVaporSaturationPressure100(waterTemperature) -
      calculatePartialWaterVaporSaturationPressure(
        airTemperature,
        relativeHumidityPoolArea
      )) *
    waterSurface *
    0.6
  );
}

//Total mass flow of water (used pool)
export function calculateTotalMassFlowOfWater(
  massFlowAttractions,
  massFlowUsed,
  visitorsMoisture
) {
  return massFlowAttractions + massFlowUsed + visitorsMoisture;
}

/************************/
//Formule iz dela Maximum air volume required for dehumidification
/************************/
//Mass flow of outside air
export function calculateMassFlowOutsideAir(
  massFlowOfWaterUnusedPool,
  totalMassFlowOfWater,
  absoluteHumidityPoolArea,
  absoluteHumiditySupplyAir
) {
  let massFlowOutsideAir;
  console.log(
    massFlowOfWaterUnusedPool,
    totalMassFlowOfWater,
    absoluteHumidityPoolArea,
    absoluteHumiditySupplyAir
  );

  if (massFlowOfWaterUnusedPool > totalMassFlowOfWater) {
    massFlowOutsideAir =
      massFlowOfWaterUnusedPool /
      (absoluteHumidityPoolArea - absoluteHumiditySupplyAir);
  } else
    massFlowOutsideAir =
      totalMassFlowOfWater /
      (absoluteHumidityPoolArea - absoluteHumiditySupplyAir);
  return massFlowOutsideAir;
}
//Maximum required amount of air
export function calculateMaximumRequiredAmountOfAir(massFlowOutsideAir) {
  let maximumRequiredAmountOfAir =
    Math.floor(massFlowOutsideAir / 1.14 / 100) * 100;
  return maximumRequiredAmountOfAir;
}

//Minimum required amount of fresh air
export function calculateMinimimReqiredAmountOfFreshAir(
  maximumRequiredAmountOfAir
) {
  return Math.ceil((maximumRequiredAmountOfAir * 0.3) / 100) * 100;
}
//Number of air chnges in the pool area
export function calculateNumberOfAirChangesPoolArea(
  maximumRequiredAmountOfAir,
  poolRoomVolume
) {
  return maximumRequiredAmountOfAir / +poolRoomVolume;
}

/************************/
//Formule iz dela AHU size selection
/************************/

//Airflow per unit
export function calculateAirFlowPerUnit(
  maximumRequiredAmountOfAir,
  numOfUnits
) {
  return maximumRequiredAmountOfAir / numOfUnits;
}

//Unit dimensions, UnitWeight, Price iz baze

//Dehumidification capacity [VDI 2089]
export function calculateDehumidificationCapacity(maximumRequiredAmountOfAir) {
  return (
    Math.round(1.14 * maximumRequiredAmountOfAir * (0.0143 - 0.009) * 100) / 100
  );
}

/************************/
//Formule iz dela AHU Accesories
/************************/
